import '../css/rewardTable.css';

function getProbability(sectionName, probability) {
    return sectionName === '캡슐 머신' ? (probability / 30).toFixed(2) : probability / 100
}

function RewardTable({data, sectionName, sectionList, viewList}) {
    const rewards = {};
    let viewCount = 0;
    sectionList.forEach((section) => {
        rewards[viewList[viewCount]] = data.filter((row) => row.sectionName === sectionName && row.section === section);
        ++viewCount;
    });

    return (
        <div className="container">
            <div className="rewardTable">
                <h3 className="sub_title">{sectionName}</h3>

                <div className="rewardTable_box">
                    {sectionList.map((el, i) => (
                        <div key={viewList[i]}>
                            <h4>{viewList[i]}</h4>

                            <div className="rewardTable_table">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>이름</th>
                                        <th>개수</th>
                                        <th>확률</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rewards[viewList[i]]?.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{item.name}</td>
                                            <td>{item.qty}</td>
                                            <td>{getProbability(sectionName, item.probabiliy)}%</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}


export default RewardTable;